export const initialUserState = {
  id:'',
  userName: {firstName:'', lastName:''},
  role: '',
  email: '',
  phoneNumber: '',
  aiAvailable: false,
  /** The AI call this agent is on, or null. Socket-driven; seeded by the navbar on mount. */
  aiOpenCall: null,
  acceptAiCall: false,
  aiAgentId: null,
  viewAgentAiCall: null,
  status:'',
  companyId: null,
  impersonateUserId: null,
  userCompanies: null,
  impersonateRole: null,

};
export const initialServerState = {
  isFetching: true,
  isSuccess: false,
  isError: false,
  errorMessage:null,
};

export const cleanedServerState = {
  ...initialServerState, ...{isFetching: false}
};